export const productsSliderOptions = (instance, options) => {
    let onEvents = {}
    let responsiveItemCounts = {
        1024: 3,
        1280: 4,
    }

    if (instance.classList.contains('is-article-content')) {
        responsiveItemCounts = {
            1024: 2
        }

        onEvents.afterInit = (swiper) => {
            if (!swiper.allowSlideNext && !swiper.allowSlidePrev) {
                swiper.$el[0].classList.add('wanna-be-centered');
            } else {
                swiper.$el[0].classList.remove('wanna-be-centered');
            }
        }

        onEvents.resize = (swiper) => {
            if (!swiper.allowSlideNext && !swiper.allowSlidePrev) {
                swiper.$el[0].classList.add('wanna-be-centered');
            } else {
                swiper.$el[0].classList.remove('wanna-be-centered');
            }
        }
    }

    let breakpoints = {}
    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution]

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: count,
            cssMode: false,
            pagination: {
                dynamicBullets: false,
            }
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 0,
        cssMode: true,
        breakpoints: breakpoints,
        on: onEvents
    }
}